import { Form, Divider, Row, Col, InputNumber, Space, Card, Input, Button, Flex, Skeleton } from "antd";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import TextArea from "antd/es/input/TextArea";
import "./style/index.scss";
import { CheckCircleTwoTone, CheckOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { formataStringDataAPI } from "../../../../util/dataAuxiliar";
import { setPageSorteio } from "../../../../redux/slices/sorteio/sorteioSlice";
import { atualizarResumoSorteio, buscarResumoSorteio } from "../../../../services/sorteioService";

const ResumoPage = () => {
  //estados globais
  const sorteioState = useAppSelector((state) => state.sorteio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    if (sorteioState.entity.id !== null && sorteioState.entity.idEmpresa !== null) {
      dispatch(
        buscarResumoSorteio({
          idSorteio: sorteioState.entity.id,
          idEmpresa: sorteioState.entity.idEmpresa,
        })
      );
    }

    dispatch(setTitle("VISÃO DETALHADA DO SORTEIO"));
  }, [sorteioState.entity]);

  useEffect(() => {
    if (sorteioState.listResumo.length !== 0) {
      form.setFieldsValue({
        ...sorteioState.listResumo[0],
        dataSorteio: formataStringDataAPI(sorteioState.listResumo[0]?.dataSorteio),
      });
    }
  }, [sorteioState.listResumo]);

  const atualizar = () => {
    const observacao = form.getFieldValue("observacao");
    dispatch(atualizarResumoSorteio({ value: { id: sorteioState.listResumo[0].id, observacao: observacao }, busca: sorteioState.busca }));
  };

  const voltar = () => {
    dispatch(setPageSorteio("geral"));
  };

  return (
    <Flex gap={12} vertical>
      <Flex justify="space-between" align="center">
        <Flex onClick={voltar} className="voltar">
          {"<"} VOLTAR
        </Flex>
        {!sorteioState.loadingResumo && (
          <Button icon={<CheckOutlined />} className="buttonPrimary" onClick={atualizar}>
            Salvar
          </Button>
        )}
      </Flex>
      {sorteioState.loadingResumo ? (
        <Flex vertical>
          <Skeleton active />
        </Flex>
      ) : (
        <Flex vertical>
          <Form form={form} layout="vertical" className="formResumo">
            <Space align="start" direction="vertical" className="spaceSorteio">
              <Divider orientation="left" orientationMargin="0" className="dividerSorteio">
                Dados base do sorteio
              </Divider>
              <Space className="grid">
                <Card className="cardResumo" variant="borderless">
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Empresa" name="apelidoEmpresa">
                        <Input size="small" style={{ width: "270px", paddingTop: "5px" }} type="text" disabled />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="Data do sorteio" name="dataSorteio">
                        <Input
                          size="small"
                          style={{
                            width: "185px",
                            paddingTop: "5px",
                            textAlign: "end",
                          }}
                          type="text"
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="Número do sorteio" name="numeroExtracao">
                        <InputNumber size="small" controls={false} style={{ width: "185px", paddingTop: "5px" }} type="number" disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Número CG" name="numeroCG">
                        <InputNumber style={{ width: 270 }} controls={false} disabled />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="Número de série" name="tamanhoSerie">
                        <InputNumber style={{ width: 185 }} controls={false} disabled />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Form.Item label="Valor do certificado" name="valorTitulo">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          style={{ width: 185 }}
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
                <Card variant="borderless" className="cardResumo">
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Notas" name="observacao">
                        <TextArea
                          style={{
                            width: "400px",
                            height: "121px",
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Space>
            </Space>
            <Space align="start" className="spacePremiacao">
              <Card variant="borderless" className="cardResumo premiacao">
                <Divider orientation="left" orientationMargin="0">
                  Premiação
                </Divider>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="Premiação Líquida" name="valorTotalPremiacaoLiquido">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Premiação Bruta" name="valorTotalPremiacaoBruto">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="Grade de prêmios">
                      <Input type="text" disabled value="1º Prêmio" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="  " name="valorPremio1">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="">
                      <Input type="text" disabled value="2º Prêmio" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="" name="valorPremio2">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="">
                      <Input type="text" disabled value="3º Prêmio" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="" name="valorPremio3">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="">
                      <Input type="text" disabled value="4º Prêmio" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="" name="valorPremio4">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="">
                      <Input type="text" style={{ width: "270px" }} disabled value="5º Prêmio" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="" name="valorPremio5">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Card variant="borderless" className="cardResumo">
                <Divider orientation="left" orientationMargin="0">
                  Quotas
                </Divider>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Sorteio" name="quotaSorteio">
                      <NumericFormat className="ant-input noBoderColor number-input" decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} disabled style={{ width: "270px" }} />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item label="Resgate" name="quotaResgate">
                      <NumericFormat className="ant-input noBoderColor number-input" decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} disabled style={{ width: "270px" }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Carregamento" name="quotaCarregamento">
                      <NumericFormat className="ant-input noBoderColor number-input" decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} disabled style={{ width: "270px" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Space>
            <Space align="start" direction="vertical" className="spaceSorteio">
              <Divider orientation="left" orientationMargin="0">
                Dados sobre as vendas
              </Divider>
              <Space>
                <Card className="cardResumo" variant="borderless">
                  <Row gutter={12}>
                    <Col span={8}>
                      <Form.Item label="Venda mínima (qtd)" name="quantidadeVendaMinima">
                        <InputNumber size="small" controls={false} style={{ width: "270px", paddingTop: "5px" }} type="number" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Quantidade vendida" name="quantidadeVendida">
                        <InputNumber size="small" controls={false} style={{ width: "270px", paddingTop: "5px" }} type="number" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="(Venda mínima - Quantidade vendida)" name="difMinimaVendida">
                        <InputNumber size="small" controls={false} style={{ width: "270px", paddingTop: "5px" }} type="number" disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col span={8}>
                      <Form.Item label="Ponto de equilíbrio" name="pontoEquilibrio">
                        <NumericFormat className="ant-input noBoderColor number-input" decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} disabled style={{ width: "270px" }} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Vendas sem doação" name="vendaSemDoacao">
                        <NumericFormat className="ant-input noBoderColor number-input" decimalSeparator="," decimalScale={2} suffix="%" fixedDecimalScale={true} disabled style={{ width: "270px" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Space>
            </Space>
            <Space align="start" className="spacePremiacao">
              <Card variant="borderless" className="cardResumo premiacao">
                <Divider orientation="left" orientationMargin="0">
                  Fluxo de valores
                </Divider>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="Faturamento total" name="faturamentoTotal">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Valor contribuido ao corporativo" name="valorContribuidoCorporativo">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="Valor retido pela regional (20%)" name="valorRetitoRegional">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Total de despesas da base" name="totalDespesaBase">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="10% da CAP" name="cap10">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Despesas REDEPOS" name="despesaRedepos">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="10% da entidade - Doações" name="entidade10">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Despesas 4Ways" name="despesa4way">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item label="% de imposto retido pela base" name="impostoRetidoBase">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Card variant="borderless" className="cardResumo">
                <Divider orientation="left" orientationMargin="0">
                  Aportes entidade
                </Divider>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Promobem -> CAP(Aporte)" name="promobemAporte">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Ressarcimento aporte (Entidade)" name="recebimentoAporte">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Sorteio ressarcido" name="dataSorteioRessarcido">
                      <Input
                        size="small"
                        style={{
                          width: "270px",
                          paddingTop: "5px",
                          textAlign: "end",
                        }}
                        type="text"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={12}>
                  <Col>
                    <Form.Item label="Valor de cobertura do corporativo" name="valorCoberturaCorporativo">
                      <NumericFormat
                        className="ant-input noBoderColor number-input"
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        prefix="R$"
                        fixedDecimalScale={true}
                        disabled
                        style={{ width: "270px" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Space>
            <Space align="start" direction="vertical" className="spaceSorteio spaceSuperavit">
              <Divider orientation="left" orientationMargin="0">
                Resultados
              </Divider>
              <Space align="start" className="spaceCardSuperavit">
                <Card className="cardResumo" variant="borderless">
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "space-between", width: "270px" }}>
                        Superávit CAP <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Transf. CAP -> Promobem" name="transfCAPPromobem">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "end", width: "270px" }}>
                        <CheckCircleTwoTone twoToneColor="#d9d9d9" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Transf. Promobem -> CAP" name="transfPromobemCAP">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
                <Card className="cardResumo" variant="borderless">
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "space-between", width: "270px" }}>
                        Superávit Entidade <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Entidade -> 4Ways (Pagamento)" name="entidade4Ways">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Entidade -> Promobem" name="entidadePromobem">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "end", width: "270px" }}>
                        <CheckCircleTwoTone twoToneColor="#d9d9d9" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Doação Promobem -> Entidade" name="doacaoPromobemEntidade">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
                <Card className="cardResumo" variant="borderless">
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "space-between", width: "270px" }}>
                        Promobem Saldo + <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Repasse conta de investimentos" name="repasseContaInvestimento">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={12} justify="space-between">
                    <Col>
                      <Title level={4} style={{ display: "flex", justifyContent: "end", width: "270px" }}>
                        <CheckCircleTwoTone twoToneColor="#d9d9d9" style={{ fontSize: "20px" }} />
                      </Title>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col>
                      <Form.Item label="Suporte conta de investimentos" name="suporteInvestimento">
                        <NumericFormat
                          className="ant-input noBoderColor number-input"
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          prefix="R$"
                          fixedDecimalScale={true}
                          disabled
                          style={{ width: "270px" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </Space>
            </Space>
          </Form>
        </Flex>
      )}
    </Flex>
  );
};

export default ResumoPage;
